import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from "@components/atoms";
import { CartPromoCode } from "@temp/components/OverlayManager/Cart/CartPromoCode";
import ProductList from "@temp/components/OverlayManager/Cart/ProductList";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { CartSummaryCosts } from "..";
import PhoneImg from "../../../../images/phone-contact.svg";
import * as S from "./styles";

/**
 * Cart summary displayed in checkout page
 */
var CartSummary = function CartSummary(_ref) {
  var subtotal = _ref.subtotal,
      total = _ref.total,
      shipping = _ref.shipping,
      promoCode = _ref.promoCode,
      products = _ref.products,
      mobileCartOpened = _ref.mobileCartOpened,
      items = _ref.items,
      toggleMobileCart = _ref.toggleMobileCart;
  var intl = useIntl();
  var count = (products === null || products === void 0 ? void 0 : products.reduce(function (acc, current) {
    return acc + current.quantity;
  }, 0)) || 0;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      promoCodeLoading = _useState2[0],
      setPromoCodeLoading = _useState2[1];

  return React.createElement(S.Wrapper, {
    mobileCartOpened: mobileCartOpened
  }, React.createElement(S.CloseBtn, {
    mobileCartOpened: mobileCartOpened,
    onClick: toggleMobileCart
  }, React.createElement("span", null), React.createElement("span", null)), React.createElement(S.Title, {
    "data-cy": "cartSummaryTitle",
    mobileCartOpened: mobileCartOpened,
    onClick: toggleMobileCart
  }, React.createElement("span", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Shopping cart",
    "id": "@next.components.organisms.CartSummary.CartSummary.2719273225"
  }, "id", "@next.components.organisms.CartSummary.CartSummary.2719273225"))), React.createElement(S.Count, {
    empty: !count,
    mobileCartOpened: mobileCartOpened
  }, count), React.createElement(S.ArrowUp, {
    mobileCartOpened: mobileCartOpened
  }, React.createElement(Icon, {
    name: "arrow_up",
    size: 24
  }))), React.createElement(S.Content, {
    mobileCartOpened: mobileCartOpened
  }, React.createElement(S.CartSummaryProductList, null, items && React.createElement(ProductList, {
    lines: items,
    readonly: true
  })), React.createElement(S.CartSummaryInfo, null, React.createElement(S.CartSummaryInner, null, React.createElement(CartSummaryCosts, {
    subtotal: subtotal,
    total: total,
    shipping: shipping,
    promoCode: promoCode,
    promoCodeLoading: promoCodeLoading
  }), React.createElement(CartPromoCode, {
    loading: promoCodeLoading,
    setLoading: setPromoCodeLoading
  }), React.createElement(S.Contact, null, React.createElement("img", {
    src: PhoneImg,
    alt: "img"
  }), React.createElement("div", {
    className: "contact-info"
  }, React.createElement("div", {
    className: "contact-title"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Contact if you have any question",
    "id": "@next.components.organisms.CartSummary.CartSummary.4088792015"
  }, "id", "@next.components.organisms.CartSummary.CartSummary.4088792015"))), React.createElement("div", {
    className: "contact-phone"
  }, "+48 799 399 390")))))));
};

export { CartSummary };